import { PlatformChip } from "@/components/PlatformBadge";
import { fmtCompact } from "@/lib/format";

function Creative({ post, big }) {
  return (
    <div data-testid={`working-${post.post_id}`} className={`group relative overflow-hidden rounded-2xl ${big ? "sm:col-span-2 sm:row-span-2" : ""}`}>
      <img src={post.thumbnail_url} alt={post.caption} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
      <div className="absolute inset-x-0 top-0 p-3"><PlatformChip platform={post.platform} /></div>
      <div className="absolute inset-x-0 bottom-0 p-4 text-white">
        <p className="mb-1 line-clamp-1 text-sm font-medium opacity-90">{post.caption}</p>
        <div className="flex items-center gap-4">
          <div><p className={`font-bold leading-none ${big ? "text-2xl" : "text-lg"}`}>{fmtCompact(post.reach)}</p><p className="text-[11px] opacity-75">Reach</p></div>
          <div><p className={`font-bold leading-none ${big ? "text-2xl" : "text-lg"}`}>{fmtCompact(post.engagement)}</p><p className="text-[11px] opacity-75">Engagement</p></div>
        </div>
      </div>
    </div>
  );
}

export default function WhatsWorking({ posts }) {
  if (!posts?.length) return null;
  return (
    <section data-testid="whats-working">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold tracking-tight">What's Working</h2>
          <p className="text-sm text-muted-foreground">The content driving your performance right now.</p>
        </div>
      </div>
      <div className="grid auto-rows-[150px] grid-cols-2 gap-4 sm:auto-rows-[180px] sm:grid-cols-4">
        {posts.map((p, i) => <Creative key={p.post_id} post={p} big={i === 0} />)}
      </div>
    </section>
  );
}
